import React, { useEffect } from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import './LegalPages.css';

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="legal-page">
      <Navbar cartItemCount={0} />
      
      <div className="legal-content">
        <div className="legal-container">
          <h1>Política de Privacidad</h1>
          <p className="last-updated">Última actualización: {new Date().toLocaleDateString('es-AR')}</p>

          <section className="legal-section">
            <h2>1. Introducción</h2>
            <p>
              Sol y Luna Kiosko ("nosotros", "nuestro" o "la empresa") se compromete a proteger su privacidad. 
              Esta Política de Privacidad explica cómo recopilamos, utilizamos, divulgamos y salvaguardamos su información 
              cuando utiliza nuestro sitio web y servicios en línea.
            </p>
          </section>

          <section className="legal-section">
            <h2>2. Información que Recopilamos</h2>
            <p>Recopilamos información de varias formas:</p>
            
            <h3>2.1 Información proporcionada voluntariamente</h3>
            <ul>
              <li>Nombre completo</li>
              <li>Dirección de correo electrónico</li>
              <li>Número de teléfono</li>
              <li>Dirección de envío y facturación</li>
              <li>Historial de compras</li>
              <li>Preferencias de productos</li>
            </ul>

            <h3>2.2 Información recopilada automáticamente</h3>
            <ul>
              <li>Dirección IP</li>
              <li>Tipo de navegador y dispositivo</li>
              <li>Páginas visitadas y tiempo de permanencia</li>
              <li>Cookies y tecnologías similares</li>
              <li>Ubicación geográfica (con consentimiento)</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>3. Uso de la Información</h2>
            <p>Utilizamos la información recopilada para:</p>
            <ul>
              <li>Procesar y cumplir con sus pedidos</li>
              <li>Enviar información de cuenta y cambios de contraseña</li>
              <li>Responder a sus preguntas, comentarios o solicitudes de servicio</li>
              <li>Enviar actualizaciones de seguridad y de soporte técnico</li>
              <li>Proporcionar boletines, ofertas y promociones (con consentimiento)</li>
              <li>Analizar el uso del sitio para mejorar nuestros servicios</li>
              <li>Detectar, prevenir y abordar fraudes y problemas técnicos</li>
              <li>Cumplir con leyes y regulaciones aplicables</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>4. Cookies y Tecnologías de Seguimiento</h2>
            <p>
              Utilizamos cookies y tecnologías de seguimiento similares para rastrear la actividad en nuestro sitio 
              y mantener cierta información. Esto incluye:
            </p>
            <ul>
              <li><strong>Cookies esenciales:</strong> Necesarias para el funcionamiento del sitio</li>
              <li><strong>Cookies de análisis:</strong> Nos ayudan a entender cómo se usa nuestro sitio</li>
              <li><strong>Cookies de marketing:</strong> Se utilizan para rastrear sus preferencias</li>
            </ul>
            <p>
              Puede controlar las preferencias de cookies a través de la configuración de su navegador. 
              Sin embargo, rechazar cookies puede afectar su experiencia en el sitio.
            </p>
          </section>

          <section className="legal-section">
            <h2>5. Compartir Información</h2>
            <p>
              No vendemos, comercializamos ni transferimos su Información de Identificación Personal a terceros sin su consentimiento, 
              excepto en los siguientes casos:
            </p>
            <ul>
              <li>Proveedores de servicios que nos ayudan a operar nuestro sitio y conducir nuestro negocio</li>
              <li>Cuando sea requerido por ley o para proteger nuestros derechos</li>
              <li>Procesadores de pagos autorizados</li>
              <li>Proveedores de envíos y logística</li>
              <li>Asociados de marketing (únicamente con su consentimiento)</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>6. Seguridad de los Datos</h2>
            <p>
              Implementamos medidas de seguridad administrativa, técnicas y físicas para proteger su información personal 
              contra acceso no autorizado, alteración, divulgación o destrucción. Utilizamos:
            </p>
            <ul>
              <li>Cifrado SSL/TLS para transmisión de datos</li>
              <li>Firewalls y sistemas de detección de intrusiones</li>
              <li>Acceso restringido a información personal</li>
              <li>Auditorías de seguridad regulares</li>
            </ul>
            <p>
              Sin embargo, ningún método de transmisión por Internet o almacenamiento electrónico es 100% seguro. 
              Aunque nos esforzamos por usar medios comercialmente aceptables para proteger su información personal, 
              no podemos garantizar su seguridad absoluta.
            </p>
          </section>

          <section className="legal-section">
            <h2>7. Retención de Datos</h2>
            <p>
              Retemos su información personal durante el tiempo que sea necesario para cumplir con los propósitos 
              establecidos en esta Política de Privacidad o según lo requerido por la ley aplicable. 
              Generalmente, retemos información:
            </p>
            <ul>
              <li>De cuenta mientras tenga una cuenta activa</li>
              <li>De transacciones durante 7 años (requisito fiscal)</li>
              <li>De comunicaciones durante 1 año después del último contacto</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>8. Sus Derechos de Privacidad</h2>
            <p>Dependiendo de su ubicación, puede tener derecho a:</p>
            <ul>
              <li>Acceder a su información personal</li>
              <li>Solicitar la corrección de información inexacta</li>
              <li>Solicitar la eliminación de su información</li>
              <li>Retirar el consentimiento para el procesamiento</li>
              <li>Oposición al procesamiento de datos para fines de marketing</li>
              <li>Portabilidad de datos</li>
            </ul>
            <p>
              Para ejercer estos derechos, contáctenos en: <strong>privacidad@solylunakiosko.com</strong>
            </p>
          </section>

          <section className="legal-section">
            <h2>9. Política de Menores de Edad</h2>
            <p>
              No recopilamos intencionalmente información personal de menores de 13 años. 
              Si creemos que hemos recopilado información de un menor de 13 años, 
              la eliminaremos inmediatamente. Si usted es menor de 18 años, puede requerir el consentimiento de un padre o tutor.
            </p>
          </section>

          <section className="legal-section">
            <h2>10. Enlaces a Otros Sitios</h2>
            <p>
              Nuestro sitio puede contener enlaces a otros sitios web que no están bajo nuestro control. 
              Esta Política de Privacidad no se aplica a esos sitios externos. Le recomendamos revisar la política de privacidad 
              de cualquier sitio antes de proporcionar su información personal.
            </p>
          </section>

          <section className="legal-section">
            <h2>11. Cambios a esta Política</h2>
            <p>
              Nos reservamos el derecho de actualizar esta Política de Privacidad en cualquier momento. 
              Los cambios entrarán en vigor inmediatamente después de su publicación en el sitio web. 
              Se le notificará sobre cambios significativos mediante correo electrónico o prominente en el sitio.
            </p>
          </section>

          <section className="legal-section">
            <h2>12. Contacto</h2>
            <p>Si tiene preguntas sobre esta Política de Privacidad, contáctenos en:</p>
            <div className="contact-info">
              <p><strong>Sol y Luna Kiosko</strong></p>
              <p>Email: privacidad@solylunakiosko.com</p>
              <p>Teléfono: +54 (código) XXXXXXX</p>
              <p>Dirección: Chacabuco y Lavalle, Argentina</p>
            </div>
          </section>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default PrivacyPolicy;

